import { render, staticRenderFns } from "./WebhookRemoved.vue?vue&type=template&id=4596009e&scoped=true"
import script from "./WebhookRemoved.vue?vue&type=script&lang=js"
export * from "./WebhookRemoved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4596009e",
  null
  
)

export default component.exports